<template>
  <div class="contact-us">
    <a :href="`tel:${supplierPhone}`">Need help?<br>Call <b>{{ supplierPhone }}</b></a>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data () {
    return {
      supplierPhone: process.env.VUE_APP_SUPPLIER_PHONE
    };
  }
};
</script>

<style lang="scss">
.contact-us {
  a {
    color: $font-paragraph-colour;
    padding: 10px 0;

    &:hover,
    &:focus {
      color: lighten($font-paragraph-colour, 10%);
      text-decoration: none;
    }
  }

  small {
    display: block;
    font-size: 65%;
  }
}
</style>
